import { Classes, EditableText, Label } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { isTesting } from 'vet-bones/utils';
import { useDidValueChange } from 'vet-bones/utils/hooks';

import { TEST_IDS } from 'src/constants/testIds';

type ProjectDiagramEditableTextProps = {
  header: string;
  isHighlighted?: boolean;
  onSetValue: (value: string) => void;
  placeholder?: string;
  value: string;
};

export const ProjectDiagramEditableTextArea: React.VFC<
  ProjectDiagramEditableTextProps
> = ({ header, isHighlighted, value, placeholder, onSetValue }) => {
  const [inputValue, setInputValue] = React.useState<string>(value);

  const didValueChange = useDidValueChange(value);
  React.useEffect(() => {
    if (didValueChange) {
      setInputValue(value);
    }
  }, [didValueChange, value]);

  const onCommit = React.useCallback(
    (value: string) => {
      setInputValue(value.trim());
      onSetValue(value.trim());
    },
    [onSetValue]
  );
  return (
    <div
      className="sd-project-diagram-editable-text-area"
      data-testid={TEST_IDS.projectDiagram.entityDrawer.description}
    >
      <Label className="sd-project-diagram-editable-text-area-label">
        {header}
      </Label>
      <div
        className={classNames(Classes.CALLOUT, 'sd-draft-highlight-candidate', {
          'sd-draft-highlight-candidate--highlighted': isHighlighted,
        })}
      >
        <EditableText
          // the way blueprintjs swaps an input for a span makes testing awkward,
          // so only use an input element when testing
          alwaysRenderInput={isTesting()}
          confirmOnEnterKey
          maxLines={2}
          minLines={2}
          multiline
          onChange={setInputValue}
          onConfirm={onCommit}
          placeholder={placeholder || ''}
          value={inputValue}
        />
      </div>
    </div>
  );
};
